import {
  EyeIcon,
  TrashIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PostDetailsModal from "../../component/SettingsPostPage/PostDetailsModal";
import ConfirmDeleteModal from "../../component/sharedComponents/ConfirmDeleteModal";
import Pagination from "../../component/sharedComponents/Pagination";
import avatar from "../../assets/images/Avatar.avif"
import { setFilter } from "../../slices/searchSlice";
import { deleteReview, getAllReviewsAdmin, toggleReviewStatus } from "../../slices/8-review/thunk";
import SectionLoader from "../../component/sharedComponents/Loading/SectionLoader";
import ReviewDetailsModal from "../../component/SettingsReviewPage/ReviewDetailsModal";

const SettingsReviewPage = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const { reviews, pagination, loading } = useSelector((state) => state.review)
  const { query, filter } = useSelector((state) => state.search);

  const [selectedreview, setSelectedReview] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectDeleteReview, setSelectDeleteReview] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const locale = i18n.language === "ar" ? "ar-EG" : "en-US";

  useEffect(() => {
    dispatch(getAllReviewsAdmin({ limit: 10, page: 1 }))
  }, [dispatch])


  useEffect(() => {
    dispatch(
      getAllReviewsAdmin({
        page: 1,
        limit: 10,
        search: query,
      })
    );
  }, [query, filter, dispatch]);


  const openDeleteModal = (post) => {
    setSelectDeleteReview(post);
    setIsDeleteModalOpen(true);
  };


  const closeDeleteModal = () => {
    setSelectDeleteReview(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = (id) => {
    dispatch(deleteReview(id));
    closeDeleteModal();
  };
  const openModal = (post) => {
    setSelectedReview(post);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedReview(null);
    setIsModalOpen(false);
  };



  const handleToggle = (id) => {
    dispatch(toggleReviewStatus(id));
  }


  const handlePageChange = (page) => {
    // dispatch(getAllPostsAdmin({ page, limit: 10 }));
  };

  // const filteredPosts = posts?.filter(post =>
  //   post?.text?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //   post?.User?.fullName?.toLowerCase().includes(searchQuery.toLowerCase())
  // );


  // const reviews = [
  //   {
  //     id: "rev_1",
  //     company: "Google",
  //     text: "Excellent service and very professional team. Highly recommended!",
  //     createdAt: "2025-01-12T10:30:00Z",
  //     isActive: true,
  //     User: {
  //       fullName: "Ahmed Mohamed",
  //       avatar: "https://i.pravatar.cc/150?img=1",
  //     },
  //   },
  //   {
  //     id: "rev_2",
  //     company: "Microsoft",
  //     text: "Good experience overall but delivery was slightly delayed.",
  //     createdAt: "2025-01-15T14:20:00Z",
  //     isActive: false,
  //     User: {
  //       fullName: "Sara Ali",
  //       avatar: "https://i.pravatar.cc/150?img=5",
  //     },
  //   },
  //   {
  //     id: "rev_3",
  //     company: "Amazon",
  //     text: "Amazing support team and fast response time!",
  //     createdAt: "2025-01-18T09:10:00Z",
  //     isActive: true,
  //     User: {
  //       fullName: "Omar Hassan",
  //       avatar: "https://i.pravatar.cc/150?img=12",
  //     },
  //   },
  //   {
  //     id: "rev_4",
  //     company: "Netflix",
  //     text: "The platform is very user-friendly and intuitive.",
  //     createdAt: "2025-01-20T16:45:00Z",
  //     isActive: true,
  //     User: {
  //       fullName: "Mona Khaled",
  //       avatar: "https://i.pravatar.cc/150?img=20",
  //     },
  //   },
  //   {
  //     id: "rev_5",
  //     company: "Tesla",
  //     text: "Innovative solutions and outstanding performance.",
  //     createdAt: "2025-01-25T11:05:00Z",
  //     isActive: false,
  //     User: {
  //       fullName: "Youssef Adel",
  //       avatar: "https://i.pravatar.cc/150?img=30",
  //     },
  //   },
  // ];


  // console.log(reviews)
  return (
    <div className="w-full space-y-4 text-gray-900 dark:text-gray-100">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-xl font-semibold text-black dark:text-white">
          {t("reviews.title")}
        </h1>
      </div>

      {/* ===== Table Wrapper ===== */}
      <div className="relative overflow-x-auto no-scrollbar w-[90vw] md:w-full">
        {/* IMPORTANT: min-width */}
        <div className="w-full">

          {loading ? <SectionLoader /> : reviews?.length === 0 ? <p className="w-full text-center">{t("NotFound")}</p> :
            <>
              <table className="w-full text-sm text-left border rounded-xl dark:border-border-dark border-border-light">
                <thead className="text-xs uppercase dark:bg-bg-dark-secondary bg-bg-light-secondary">
                  <tr className="text-center">
                    <th className="px-4 py-3">{t("reviews.ID")}</th>
                    <th className="px-4 py-3">{t("reviews.profile")}</th>
                    <th className="px-4 py-3">{t("reviews.fullName")}</th>
                    <th className="px-4 py-3">{t("reviews.company")}</th>
                    <th className="px-4 py-3">{t("reviews.text")}</th>
                    <th className="px-4 py-3">{t("reviews.date")}</th>
                    <th className="px-4 py-3 text-center">
                      {t("reviews.actions")}
                    </th>
                  </tr>
                </thead>
                <tbody className="py-2 dark:bg-bg-dark-secondary bg-bg-light-secondary">
                  {
                    reviews?.map((review, index) => (
                      <>
                        {/* divider */}
                        <tr>
                          <td colSpan={7} className="px-4 ">
                            <div className="mx-4 border-t dark:border-border-dark border-border-light"></div>
                          </td>
                        </tr>
                        <tr
                          key={review?.id}
                          className="px-2 text-center duration-300 hover:bg-bg-light-primary dark:hover:bg-bg-dark-primary"
                        >
                          <td className="px-2 py-3">{index + 1}</td>
                          <td className="flex justify-center px-2">
                            <img
                              src={review?.User?.avatar || avatar}
                              className="w-8 h-8 rounded-full"
                              alt={review?.User?.fullName}
                            />
                          </td>
                          <td className="px-2">{review?.User?.fullName}</td>
                          <td className="max-w-xs px-2 truncate">{locale === "ar" ? review?.Company?.name_AR : review?.Company?.name_EN}</td>
                          <td className="max-w-xs px-2 truncate">{review?.text}</td>
                          <td className="px-2">{new Date(review?.createdAt).toLocaleDateString()}</td>
                          {/* <td>
                            {post?.type === "ads" ? (
                              <span className="px-3 py-1 text-xs dark:text-[#00FFEA] text-[#004b45] dark:bg-[#00FFEA1A] bg-[#00ffea] rounded-xl">
                                {t("postType.sponsored")}
                              </span>
                            ) : (
                                <span className="px-3 py-1 text-xs dark:text-[#BBFF00] text-[#3f5600] dark:bg-[#BBFF001A] bg-[#bbff00f7] rounded-xl">
                                {t("postType.post")}
                              </span>
                            )}
                          </td> */}
                          <td className="px-2">
                            <div className="flex items-center justify-center gap-3">
                              <button
                                onClick={() => openModal(review)}
                                title={t("reviews.view")}
                              >
                                <EyeIcon className="w-5 h-5 text-yellow-400" />
                              </button>
                              <button
                                onClick={() => handleToggle(review?.id)}
                                title={
                                  review?.isActive
                                    ? t("reviews.deactivate")
                                    : t("reviews.activate")
                                }
                              >
                                {review?.isActive ?
                                  <CheckCircleIcon className="w-5 h-5 text-green-400" />
                                  :
                                  <XCircleIcon className="w-5 h-5 text-red-500" />
                                }
                              </button>
                              <button onClick={() => openDeleteModal(review)}
                                title={t("reviews.delete")}
                              >
                                <TrashIcon className="w-5 h-5 text-red-500" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </>
                    ))
                  }
                </tbody>
              </table>
              {pagination && reviews?.length > 0 && (
                <Pagination
                  pagination={pagination}
                  onPageChange={(page) => handlePageChange(page)}
                />
              )}
            </>
          }
        </div>
        {selectedreview && (
          <ReviewDetailsModal isOpen={isModalOpen} onClose={closeModal} review={selectedreview} />
        )}
        {selectDeleteReview && (
          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onConfirm={confirmDelete}
            post={selectDeleteReview}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsReviewPage;
